export default __webpack_public_path__ + "static/media/login-hero.f8f67665.png";